export const getReviewCommentsCommitValue = ({ draft, value }) => {
  const currentValue = value ?? "";

  return draft === currentValue ? null : draft;
};
